import React, { useContext, useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import { FilterContext } from "@/pages/dashboard/components/PageContainer/context";
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';

export default function NewUsersTrendCo(props: any) {
  const { style, className, type, config, children, ...resetProps } = props || {};
  const {
    api,
    refreshKey = '',
    interval,
    formatData,
    rawData,
    formatRules,
    childrenServiceMap,
    extraParams,
  } = config || {};
  useContext(FilterContext);
  // 这里不直接使用 filterVal/filterLoading，Service 内部会从 FilterContext 获取

  const { gameCode } = useSelector((state: any) => {
    return {
      gameCode: state?.dashboard?.currentGame?.game_code,
    };
  }, shallowEqual);

  const data = useMemo(() => {
    return {
      gameCode,
    };
  }, [gameCode]);

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        refreshKey={refreshKey}
        interval={interval}
        formatData={formatData}
        rawData={rawData}
        formatRules={formatRules}
        dataKey={'keyMetricsData'}
        beforeRequest={(data) => {
          const { filterVal, gameCode } = data;
          const { timeType, diff, rangeTime, ...filters } = filterVal || {};
          const params = {
            game_code: gameCode,
            start_time: rangeTime?.[0] || '',
            end_time: rangeTime?.[1] || '',
            period: PERIODTIMEOBJ[timeType] || 'daily',
            filters: formatFilterValues(filters),
            ...(extraParams || {}),
          };
          return params;
        }}
        trackData={['gameCode']}>
        {React.Children.map(children, (child: any) => {
          // 子组件 service 覆盖：按 child.props.config.type 命中 childrenServiceMap
          const childType = child?.props?.config?.type;
          const override = (childType && childrenServiceMap) ? childrenServiceMap[childType] : null;

          const clonedChild = React.cloneElement(child, {
            ...resetProps,
            metricsInfo: { metricsInfo: props?.data?.metricsInfo },
            state: {},
          });

          if (!override?.api) {
            return clonedChild;
          }

          return (
            <Service
              api={override.api}
              data={data}
              interval={override.interval}
              refreshKey={override.refreshKey}
              rawData={override.rawData}
              formatData={override.formatData}
              formatRules={override.formatRules}
              dataKey={'keyMetricsData'}
              beforeRequest={(data) => {
                const { filterVal, gameCode } = data;
                const { timeType, diff, rangeTime, ...filters } = filterVal || {};
                const params = {
                  game_code: gameCode,
                  start_time: rangeTime?.[0] || '',
                  end_time: rangeTime?.[1] || '',
                  period: PERIODTIMEOBJ[timeType] || 'daily',
                  filters: formatFilterValues(filters),
                  ...(override.extraParams || {}),
                };
                return params;
              }}
              trackData={['gameCode']}
            >
              {clonedChild}
            </Service>
          );
        })}
      </Service>
    </div>
  );
};
